import angular from 'angular';

angular
    .module('container')

    .factory('ContainerService', [
        '$resource',
        'API_CONFIG',
        function ($resource, API_CONFIG) {
            var Container = $resource(
                API_CONFIG.url + '/v1/container/searchByCriterias',
                {},
                {
                    // Recherche suivant les critères
                    searchByCriterias: {
                        method: 'POST',
                        isArray: true,
                    },
                    // Compte le nombre de déposants autorisés et blacklistés
                    countContainer: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/container/countDepositor',
                        isArray: true,
                    },
                    // Liste toutes les containers
                    findAll: {
                        method: 'GET',
                        url: API_CONFIG.url + '/v1/container',
                        isArray: true,
                    },
                    // Récupère les templates d'un container
                    getContainerTemplatesForm: {
                        method: 'GET',
                        url: API_CONFIG.url + '/v1/container/templates',
                    },
                    // Désactive les containers
                    disableContainers: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/container/disable',
                    },
                    // Obtient la liste des containers pouvant être activé
                    checkEnable: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/container/check-enable',
                        isArray: true,
                    },
                    // Active les containers
                    enable: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/container/enable',
                        isArray: true,
                    },
                    //Supprimer les container
                    deleteContainers: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/container/delete',
                    },
                    //Vérifier si le container à des pils ou des fournisseur invité.
                    checkContainersDeletion: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/container/checkDeletion',
                        isArray: true,
                    },
                }
            );
            // Ajout de la propriété EidWithID
            Object.defineProperty(Container.prototype, 'DoEidWithId', {
                get: function () {
                    return this.principalEid + ' (' + this.principalAppId + ')';
                },
            });

            return Container;
        },
    ]);
